(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["northmire-ship-date"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('northmire-ship-date')) {
  customElements.define('northmire-ship-date', class extends HTMLElement {
    connectedCallback() {
      this.updateDate();
      this.refreshTimer = window.setInterval(() => this.updateDate(), 60000);
    }
    disconnectedCallback() {
      window.clearInterval(this.refreshTimer);
    }
    updateDate() {
      const date = new Date();
      date.setDate(date.getDate() + 2);
      const time = this.querySelector('time');
      if (!time) return;
      time.textContent = new Intl.DateTimeFormat('en-US', { weekday: 'long', month: 'long', day: 'numeric' }).format(date);
      time.dateTime = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
      this.hidden = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["northmire-welcome-popup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('northmire-welcome-popup')) {
  customElements.define('northmire-welcome-popup', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || this.initialized) return;
      this.initialized = true;
      this.storageKey = 'northmire-welcome-v1';
      this.dialog.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click', () => this.dismiss()));
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.dismiss(); });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dismiss();
      });
      if (this.querySelector('[data-welcome-success]')) {
        this.save({ completed: true });
        this.open();
        return;
      }
      if (this.querySelector('[data-welcome-errors]')) { this.open(); return; }
      if (this.dataset.subscribed === 'true') return;
      let state = {};
      try { state = JSON.parse(localStorage.getItem(this.storageKey) || '{}'); } catch {}
      if (state.completed || state.dismissedUntil > Date.now()) return;
      this.timer = window.setTimeout(() => {
        if (document.querySelector('dialog[open]')) return;
        this.open();
      }, 5000);
    }
    disconnectedCallback() {
      window.clearTimeout(this.timer);
    }
    open() {
      if (this.dialog.open || !this.isConnected) return;
      this.dialog.showModal();
    }
    save(state) {
      try { localStorage.setItem(this.storageKey, JSON.stringify(state)); } catch {}
    }
    dismiss() {
      if (!this.querySelector('[data-welcome-success]')) this.save({ dismissedUntil: Date.now() + 7 * 86400000 });
      this.dialog.close();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
